/* da-mobile-nav v5 — focus trap + inert + body-hoist + opaque-header-on-open fix */
(function() {
  var hamburger = document.getElementById('da-mobile-nav__hamburger');
  var panel    = document.getElementById('da-mobile-nav-panel');
  var overlay  = document.getElementById('da-mobile-nav-overlay');
  var closeBtn = document.getElementById('da-mobile-nav-close');

  if (!hamburger || !panel) return;

  // Hoist panel + overlay to <body> so position:fixed is relative to viewport,
  // not to the sticky-header ancestor which applies transform: translateY().
  document.body.appendChild(panel);
  if (overlay) document.body.appendChild(overlay);

  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function getFocusable() {
    return Array.from(panel.querySelectorAll(FOCUSABLE)).filter(function(el) {
      return !el.hasAttribute('hidden') && el.offsetParent !== null;
    });
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    var focusable = getFocusable();
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function openMenu() {
    panel.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
    hamburger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('da-menu-open');
    // Force opaque header when menu opens (prevents transparent header on homepage top)
    var hdrGroup = document.querySelector('.shopify-section-group-header-group');
    if (hdrGroup) hdrGroup.classList.add('da-scrolled');
    // Inert sur le contenu principal
    var mainContent = document.getElementById('MainContent');
    if (mainContent) mainContent.setAttribute('inert', '');
    panel.addEventListener('keydown', trapFocus);
    closeBtn && closeBtn.focus();
  }

  function closeMenu() {
    panel.classList.remove('is-open');
    overlay && overlay.classList.remove('is-visible');
    hamburger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('da-menu-open');
    // Restore header scroll state: remove da-scrolled only if still at top
    var hdrGroup = document.querySelector('.shopify-section-group-header-group');
    if (hdrGroup && (window.scrollY || window.pageYOffset) <= 60) {
      hdrGroup.classList.remove('da-scrolled');
    }
    var mainContent = document.getElementById('MainContent');
    if (mainContent) mainContent.removeAttribute('inert');
    panel.removeEventListener('keydown', trapFocus);
    hamburger.focus();
  }

  hamburger.addEventListener('click', function() {
    panel.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  closeBtn && closeBtn.addEventListener('click', closeMenu);
  overlay && overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) closeMenu();
  });

  // Accordion sous-menus
  panel.querySelectorAll('.da-mobile-nav-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.da-mobile-nav-panel__item.has-sub');
      if (!item) return;
      var isOpen = item.classList.contains('open');
      panel.querySelectorAll('.da-mobile-nav-panel__item.has-sub.open').forEach(function(el) {
        el.classList.remove('open');
        el.querySelector('.da-mobile-nav-toggle').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();
